import $ from 'jquery';
import algoliasearch from 'algoliasearch';
import algoliasearchHelper from 'algoliasearch-helper';
import Hogan from 'hogan.js';

/* eslint-disable */

$.fn.searchplus = function(config) {
    if (typeof config === 'undefined') {
        config = {};
    }

    const $input =
        typeof config.input !== 'undefined'
            ? $(config.input)
            : $('#searchinput');
    const $searchform =
        typeof config.form !== 'undefined' ? $(config.form) : $('#searchform');
    const $results_container =
        typeof config.resultsContainer !== 'undefined'
            ? $(config.resultsContainer)
            : $('#results');
    const $pagination_container =
        typeof config.paginationContainer !== 'undefined'
            ? $(config.paginationContainer)
            : $('#pagination');

    // Replace with your own values
    const APPLICATION_ID =
        typeof config.applicationId !== 'undefined'
            ? config.applicationId
            : $searchform.attr('data-applicationId');
    const SEARCH_ONLY_API_KEY =
        typeof config.searchApiKey !== 'undefined'
            ? config.searchApiKey
            : $searchform.attr('data-searchApiKey');
    const INDEX_NAME =
        typeof config.index !== 'undefined'
            ? config.index
            : $searchform.attr('data-index');
    const PARAMS = {
        hitsPerPage:
            typeof config.hitsPerPage !== 'undefined' ? config.hitsPerPage : 25,
        maxValuesPerFacet:
            typeof config.maxValuesPerFacet !== 'undefined'
                ? config.maxValuesPerFacet
                : 10,
        facets: typeof config.facets !== 'undefined' ? config.facets : [],
        disjunctiveFacets:
            typeof config.disjunctiveFacets !== 'undefined'
                ? config.disjunctiveFacets
                : [],
    };
    const SEARCHONLOAD =
        typeof config.searchOnLoad !== 'undefined' ? config.searchOnLoad : true;
    let URLHistoryTimer = Date.now();
    const URLHistoryThreshold = 700;

    const FACETS_ORDER_OF_DISPLAY =
        typeof config.facetsOrderOfDisplay !== 'undefined'
            ? config.facetsOrderOfDisplay
            : PARAMS.facets.concat(PARAMS.disjunctiveFacets);
    const FACETS_LABELS =
        typeof config.facetsLabels !== 'undefined' ? config.facetsLabels : [];
    const FACETS_FORCED_REFINEMENT =
        typeof config.facetsForcedRefinement !== 'undefined'
            ? config.facetsForcedRefinement
            : [];

    // Client + Helper initialization
    const algolia = algoliasearch(APPLICATION_ID, SEARCH_ONLY_API_KEY);
    const algoliaHelper = algoliasearchHelper(algolia, INDEX_NAME, PARAMS);

    // DOM BINDING
    const $pagination = $pagination_container;
    const $hits = $results_container;
    const $inputIcon = $('#search-input-icon');
    const $main = $('main');
    const $sortBySelect = $('#sort-by-select');
    const $stats = $('#stats');
    const $facets = $('#facets');

    const hitTemplate = Hogan.compile($('#hit-template').text());
    const statsTemplate = Hogan.compile($('#stats-template').text());
    const facetTemplate = Hogan.compile($('#facet-template').text());
    const paginationTemplate = Hogan.compile($('#pagination-template').text());
    const noResultsTemplate = Hogan.compile($('#no-results-template').text());

    // Input binding
    $input
        .on('keyup', function() {
            const query = $(this).val();
            algoliaHelper.setQuery(query).search();
        })
        .focus();

    // Prevent form submission
    $searchform.on('submit', () => false);

    // Update URL
    algoliaHelper.on('change', state => {
        setURLParams();
    });
    // Search results
    algoliaHelper.on('result', (content, state) => {
        renderHits(content);
        renderStats(content);
        renderPagination(content);
        renderFacets(content, state);
        handleNoResults(content);
    });

    $sortBySelect.on('change', function(e) {
        e.preventDefault();
        algoliaHelper.setIndex(INDEX_NAME + $(this).val()).search();
    });

    // Initial search
    // As long as we don't have a searchOnLoad = false config
    if (SEARCHONLOAD == true) {
        initFromURLParams();
        algoliaHelper.search();
    }

    for (const a in FACETS_FORCED_REFINEMENT) {
        if (typeof FACETS_FORCED_REFINEMENT[a] !== 'string') {
            for (const b in FACETS_FORCED_REFINEMENT[a]) {
                algoliaHelper.addDisjunctiveFacetRefinement(
                    a,
                    FACETS_FORCED_REFINEMENT[a][b]
                );
            }
        } else {
            algoliaHelper.addDisjunctiveFacetRefinement(
                a,
                FACETS_FORCED_REFINEMENT[a]
            );
        }
    }

    function setURLParams() {
        const trackedParameters = ['attribute:*'];
        if (algoliaHelper.state.query.trim() !== '') {
            trackedParameters.push('query');
        }
        if (algoliaHelper.state.page !== 0) {
            trackedParameters.push('page');
        }
        if (algoliaHelper.state.index !== INDEX_NAME) {
            trackedParameters.push('index');
        }

        const URLParams = window.location.search.slice(1);
        const nonAlgoliaURLParams = algoliasearchHelper.AlgoliaSearchHelper.getForeignConfigurationInQueryString(
            URLParams
        );
        const nonAlgoliaURLHash = window.location.hash;
        const helperParams = algoliaHelper.getStateAsQueryString({
            filters: trackedParameters,
            moreAttributes: nonAlgoliaURLParams,
        });
        if (URLParams === helperParams) {
            return;
        }

        const now = Date.now();
        if (URLHistoryTimer > now) {
            window.history.replaceState(
                { searchplus: true },
                '',
                `?${helperParams}${nonAlgoliaURLHash}`
            );
        } else {
            window.history.pushState(
                { searchplus: true },
                '',
                `?${helperParams}${nonAlgoliaURLHash}`
            );
        }
        URLHistoryTimer = now + URLHistoryThreshold;
    }

    function initFromURLParams() {
        const URLString = window.location.search.slice(1);
        const URLParams = algoliasearchHelper.AlgoliaSearchHelper.getConfigurationFromQueryString(
            URLString
        );
        if (URLParams.query) {
            $input.val(URLParams.query);
        }
        if (URLParams.index) {
            $sortBySelect.val(URLParams.index.replace(INDEX_NAME, ''));
        }
        algoliaHelper.overrideStateWithoutTriggeringChangeEvent(
            algoliaHelper.state.setQueryParameters(URLParams)
        );
    }

    function renderHits(content) {
        $hits.html(hitTemplate.render(content));
        $hits.addClass('active');
    }

    function renderFacets(content, state) {
        let facetsHtml = '';
        for (
            let facetIndex = 0;
            facetIndex < FACETS_ORDER_OF_DISPLAY.length;
            ++facetIndex
        ) {
            const facetName = FACETS_ORDER_OF_DISPLAY[facetIndex];
            const facetResult = content.getFacetByName(facetName);
            if (!facetResult) {
                continue;
            }
            let facetContent = {};

            // Conjunctive + Disjunctive facets
            facetContent = {
                facet: facetName,
                title: FACETS_LABELS[facetName],
                values: content.getFacetValues(facetName, {
                    sortBy: ['isRefined:desc', 'count:desc'],
                }),
                disjunctive:
                    $.inArray(facetName, PARAMS.disjunctiveFacets) !== -1,
            };
            facetsHtml += facetTemplate.render(facetContent);
        }
        $facets.html(facetsHtml);
    }

    function renderStats(content) {
        const stats = {
            nbHits: content.nbHits,
            nbHits_plural: content.nbHits !== 1,
            processingTimeMS: content.processingTimeMS,
        };
        $stats.html(statsTemplate.render(stats));
    }

    function handleNoResults(content) {
        if (content.nbHits > 0) {
            $main.removeClass('no-results');
            return;
        }

        $main.addClass('no-results');

        const filters = [];
        let i;
        let j;
        for (i in algoliaHelper.state.facetsRefinements) {
            filters.push({
                class: 'toggle-refine',
                facet: i,
                facet_value: algoliaHelper.state.facetsRefinements[i],
                label: `${FACETS_LABELS[i]}: `,
                label_value: algoliaHelper.state.facetsRefinements[i],
            });
        }
        for (i in algoliaHelper.state.disjunctiveFacetsRefinements) {
            for (j in algoliaHelper.state.disjunctiveFacetsRefinements[i]) {
                filters.push({
                    class: 'toggle-refine',
                    facet: i,
                    facet_value:
                        algoliaHelper.state.disjunctiveFacetsRefinements[i][j],
                    label: `${FACETS_LABELS[i]}: `,
                    label_value:
                        algoliaHelper.state.disjunctiveFacetsRefinements[i][j],
                });
            }
        }
        for (i in algoliaHelper.state.numericRefinements) {
            for (j in algoliaHelper.state.numericRefinements[i]) {
                filters.push({
                    class: 'remove-numeric-refine',
                    facet: i,
                    facet_value: j,
                    label: `${FACETS_LABELS[i]} `,
                    label_value: `${j} ${algoliaHelper.state.numericRefinements[
                        i
                    ][j]}`,
                });
            }
        }
        $hits.html(
            noResultsTemplate.render({
                query: content.query,
                filters,
            })
        );
    }

    function renderPagination(content) {
        const pages = [];
        if (content.page > 3) {
            pages.push({ current: false, number: 1 });
            pages.push({ current: false, number: '...', disabled: true });
        }
        for (let p = content.page - 3; p < content.page + 3; ++p) {
            if (p < 0 || p >= content.nbPages) {
                continue;
            }
            pages.push({ current: content.page === p, number: p + 1 });
        }
        if (content.page + 3 < content.nbPages) {
            pages.push({ current: false, number: '...', disabled: true });
            pages.push({ current: false, number: content.nbPages });
        }
        const pagination = {
            pages,
            prev_page: content.page > 0 ? content.page : false,
            next_page:
                content.page + 1 < content.nbPages ? content.page + 2 : false,
        };
        $pagination.html(paginationTemplate.render(pagination));
    }

    $(document).on('click', '.go-to-page', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '500', 'swing');
        algoliaHelper.setCurrentPage(+$(this).data('page') - 1).search();
    });
    $(document).on('click', '.remove-numeric-refine', function(e) {
        e.preventDefault();
        algoliaHelper
            .removeNumericRefinement(
                $(this).data('facet'),
                $(this).data('value')
            )
            .search();
    });
    $(document).on('click', '.clear-all', e => {
        e.preventDefault();
        $input.val('').focus();
        algoliaHelper
            .setQuery('')
            .clearRefinements()
            .search();
    });
    $(document).on('change', '.toggle-refine', function(e) {
        e.preventDefault();
        algoliaHelper
            .clearRefinements($(this).data('facet'))
            .addDisjunctiveFacetRefinement($(this).data('facet'), $(this).val())
            .search();
    });
    window.addEventListener('popstate', e => {
        if (e.state == null) {
            return;
        }
        initFromURLParams();
        algoliaHelper.search();
    });
};
